/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Appropriation } from './Appropriation';
import {
    AppropriationFromJSON,
    AppropriationFromJSONTyped,
    AppropriationToJSON,
} from './Appropriation';

/**
 * Wraps the appropriation DTOs.
 * @export
 * @interface AppropriationList
 */
export interface AppropriationList {
    /**
     * 
     * @type {Array<Appropriation>}
     * @memberof AppropriationList
     */
    appropriations?: Array<Appropriation>;
}

/**
 * Check if a given object implements the AppropriationList interface.
 */
export function instanceOfAppropriationList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AppropriationListFromJSON(json: any): AppropriationList {
    return AppropriationListFromJSONTyped(json, false);
}

export function AppropriationListFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppropriationList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'appropriations': !exists(json, 'appropriations') ? undefined : ((json['appropriations'] as Array<any>).map(AppropriationFromJSON)),
    };
}

export function AppropriationListToJSON(value?: AppropriationList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'appropriations': value.appropriations === undefined ? undefined : ((value.appropriations as Array<any>).map(AppropriationToJSON)),
    };
}

